import { adminApi } from './AuthContext';

const CHUNK_SIZE = 1024 * 1024;

export const uploadImage = async (file, onProgress) => {
  const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  const { data: init } = await adminApi.post('/admin/upload/init', {
    filename: file.name, content_type: file.type, size: file.size, total_chunks: totalChunks,
  });
  for (let i = 0; i < totalChunks; i++) {
    const form = new FormData();
    form.append('chunk', file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
    await adminApi.post(`/admin/upload/chunk/${init.upload_id}/${i}`, form);
    onProgress?.(Math.round(((i + 1) / totalChunks) * 90));
  }
  const { data } = await adminApi.post(`/admin/upload/complete/${init.upload_id}`);
  onProgress?.(100);
  return data; // { url, path, size }
};
